import { css } from 'styled-components'

import arrowLeft from '_assets/svg/icons/icon-arrow-left.svg'
import arrowRight from '_assets/svg/icons/icon-arrow-right.svg'
import { palette, transitions } from '_styles/variables'

export const Button = css<{ isDisabled?: boolean }>`
  text-transform: uppercase;
  cursor: pointer;

  &.disabled {
    cursor: not-allowed;
    color: ${palette.neutral['grey-bbbdbf']};

    & a {
      pointer-events: none;
    }
  }

  & a {
    line-height: 27px;
    text-align: center;
    display: inline-block;
    color: inherit;
    text-decoration: none;
  }

  &:not(:first-child) {
    margin-left: 5px;
  }

  &:not(:first-child):not(:last-child) {
    border-radius: 100%;
    transition: ${transitions.quick(['background-color'])};

    & a {
      min-width: 27px;
    }

    &:hover,
    &.active {
      color: ${palette.neutral.white};
      background-color: ${palette.neutral['primary-body']};
    }
  }

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      cursor: not-allowed;
      pointer-events: none;
      color: ${palette.neutral['grey-bbbdbf']};

      &:not(:first-child):not(:last-child).active {
        color: ${palette.neutral.white};
        background-color: ${palette.neutral['grey-d8d8d8']};
      }

      & a {
        pointer-events: none;
      }
    `}
`

export const getArrowStyle = (position: 'left' | 'right') => css<{
  isDisabled?: boolean
}>`
  position: relative;

  & a {
    ${position === 'left' ? 'padding-left' : 'padding-right'}: 1.5rem;
  }

  &.disabled::before {
    background-color: ${palette.neutral['grey-bbbdbf']};
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0.2em;
    width: 1.25em;
    height: 1.25em;
    background-color: ${palette.neutral['grey-icons']};
    ${position === 'left' ? 'left: 0;' : 'right: 0;'}
    pointer-events: none;
    mask: url(\"${position === 'left' ? arrowLeft : arrowRight}\") no-repeat;
    mask-size: 1.25em;
  }

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      &::before {
        background-color: ${palette.neutral['grey-bbbdbf']};
      }
    `}
`
